/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_TicketsInputs */

const en_admin_nav_tickets = /** @type {(inputs: Admin_Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

/**
* | output |
* | --- |
* | "Tickets" |
*
* @param {Admin_Nav_TicketsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_tickets = /** @type {((inputs?: Admin_Nav_TicketsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_TicketsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_tickets(inputs)
});
export { admin_nav_tickets as "admin.nav.tickets" }